import { render, staticRenderFns } from "./company_access.vue?vue&type=template&id=5d7c3514&scoped=true&"
import script from "./company_access.vue?vue&type=script&lang=js&"
export * from "./company_access.vue?vue&type=script&lang=js&"
import style0 from "./company_access.vue?vue&type=style&index=0&id=5d7c3514&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c3514",
  null
  
)

export default component.exports